import { stripeRepo } from "@/repositories/stripeRepo";
import { useObservable } from "@repo/ui/components/Base/hooks/useObservable";

export const useGetCoupon = (code: string) => {
  return useObservable(() => stripeRepo.getCoupon(code), [code]);
};

export const useGetStates = () => {
  return useObservable(() => stripeRepo.getStates(), []);
};

export const useGetMunicipalities = (state: string) => {
  return useObservable(() => stripeRepo.getMunicipalities(state), [state]);
};
